import * as s from "react/jsx-runtime";
const t = s.Fragment, n = s.jsx, o = s.jsxs;
export { t as Fragment, n as jsx, o as jsxs };
